module.exports = __webpack_public_path__ + "9c91f3cdac8bb20095ecdbd2dd823f3a.png";